import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSimCard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSimCard1"><Path d="M9.5 16.5V12.5H14.5V16.5H9.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M4 22V2H14.5607L20 7.43934V22H4ZM8 11V18H16V11H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSimCard1;
